import { VERIFICATION } from "../../constants";

export const setData = (payload) => ({
  type: VERIFICATION.SET_DATA,
  payload,
});